"use client";

import { useSearchParams } from "next/navigation";
import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

export function HomeContent({
  defaultOutputLocale,
}: {
  /** Citation output language to start on; localized homes pass their own. */
  defaultOutputLocale?: string;
} = {}) {
  const searchParams = useSearchParams();
  const styleParam = searchParams.get("style") ?? undefined;
  // `?source=` prefills the generator (the "Cite This Page" bookmarklet target).
  const sourceParam = searchParams.get("source") ?? undefined;

  return (
    <CitationTool
      defaultOutputLocale={defaultOutputLocale}
      defaultStyle={styleParam}
      source={sourceParam}
      styles={getFeaturedStyles()}
    />
  );
}
